var map = {
	"./about-app/game.svg": 819,
	"./about-app/learn.svg": 820,
	"./about-app/scan.svg": 821,
	"./about-app/tips.svg": 822,
	"./arrow.svg": 778,
	"./bt-round-active.svg": 787,
	"./bt-round-hover.svg": 788,
	"./bt-round.svg": 789,
	"./check-box-checked.svg": 777,
	"./close.svg": 873,
	"./contract.svg": 874,
	"./done.svg": 790,
	"./download.svg": 875,
	"./east-arrow.svg": 779,
	"./email.svg": 876,
	"./feedback.svg": 398,
	"./game.svg": 877,
	"./go.svg": 878,
	"./menu.svg": 879,
	"./next.svg": 880,
	"./polygon_arrow.svg": 782,
	"./search.svg": 881,
	"./sign.svg": 399,
	"./vertical_dots.svg": 776,
	"./words-containing-outlined.svg": 882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;